import React, { useEffect, useState,useContext } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import { Mycontext } from "../../mycontext";

const apiUrl = process.env.REACT_APP_API_URL;

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
}

const ConfirmationPage = () => {
  const query = useQuery();
  const klarna_order_id = query.get('klarna_order_id');
  const [htmlSnippet, setHtmlSnippet] = useState('');
  const [error, setError] = useState('');
  
  const context = useContext(Mycontext);
  const {  setCartItemsData } = context;

  useEffect(() => {
    if (klarna_order_id) {
      axios.get(apiUrl + `/confirmation/${klarna_order_id}`)
        .then(response => {
          const data = response.data;
          if (data.html_snippet) {
            setHtmlSnippet(data.html_snippet);
            if (data.status === "checkout_complete") 
              setCartItemsData([])
              window.localStorage.removeItem('chart') 
              window.localStorage.removeItem('klarna_order_id') 

          } else {
            setError('Failed to load the confirmation page. Please try again.');
          }
        })
        .catch(error => {
          console.error('Error:', error);
          setError('Failed to load the confirmation page. Please try again.');
        });
    } else {
      setError('Order ID not found. Please start the checkout process again.');
    }
  }, [klarna_order_id]);

  useEffect(() => {
    if (htmlSnippet) {
      const confirmationContainer = document.getElementById('confirmation-container');
      confirmationContainer.innerHTML = htmlSnippet;

      const scriptTags = confirmationContainer.getElementsByTagName('script');
      for (let i = 0; i < scriptTags.length; i++) {
        const parentNode = scriptTags[i].parentNode;
        const newScriptTag = document.createElement('script');
        newScriptTag.type = 'text/javascript';
        if (scriptTags[i].src) {
          newScriptTag.src = scriptTags[i].src;
        } else {
          newScriptTag.text = scriptTags[i].text;
        }
        parentNode.replaceChild(newScriptTag, scriptTags[i]);
      }
    }
  }, [htmlSnippet]);

  return (
    <div>
      <h1>Tilausvahvistus</h1>
      {error ? (
        <div style={{marginTop:'15vh', marginLeft:'10%'}}>
          <p>{error}</p>
          <button  onClick={() => window.location.reload()}>Uudelleenlatauksen vahvistus</button>
        </div>
      ) : (
        <div id="confirmation-container"></div>
      )}
    </div>
  );
};

export default ConfirmationPage;